/* UMOJA shell: the mobile menu on every page that is not the homepage. */
(function(){
  const mb = document.getElementById('menuBtn'), mn = document.getElementById('mmenu');
  if (!mb || !mn) return;
  const setMenu = open => { mn.hidden = !open; mb.setAttribute('aria-expanded', open); mb.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); document.body.classList.toggle('menu-open', open); };
  mb.addEventListener('click', () => setMenu(mn.hidden));
  mn.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
  addEventListener('keydown', e => { if (e.key === 'Escape' && !mn.hidden) setMenu(false); });
})();
